import React, { useCallback } from 'react';
import { useHistory } from 'react-router';
import { FormattedMessage } from 'react-intl';

import { useHandleGenerator } from '../../contexts/RoutesContext';
import { useUser, useSetUser } from '../../contexts/AuthContext';

import CountryForm from '../forms/Country';

import styles from '../../../styles/pages/form.module.scss';

const propTypes = {};

const defaultProps = {};

const CountryPage = () => {
    const history = useHistory();
    const handle = useHandleGenerator();
    const user = useUser();
    const setUser = useSetUser();
    const emailLink = handle('email');
    const showLink = handle('show');

    const onSuccess = useCallback(
        (country) => {
            setUser(country);
            history.push(country === 'CA' ? emailLink : showLink);
        },
        [history, emailLink, showLink, setUser],
    );

    return (
        <div className={styles.container}>
            <div className={styles.inner}>
                <div className={styles.content}>
                    <p>
                        <FormattedMessage
                            id="content.country.description"
                            defaultMessage="Avant de vous donner accès à la création, nous aimerions svp connaître votre lieu de résidence"
                            description="Description"
                        />
                        &nbsp;:
                    </p>
                    <CountryForm initialValue={{ country: user }} onSuccess={onSuccess} />
                </div>
            </div>
        </div>
    );
};
CountryPage.propTypes = propTypes;
CountryPage.defaultProps = defaultProps;

export default CountryPage;
